import React from "react";
import styles from "./AdminBakerySetup.module.css";
import { SubmitButton, TextComponent } from "../../../components";
import Switch from "../../../components/Switch/Switch";
import { useNavigate } from "react-router-dom";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";

const AdminBakerySetup = () => {
  const navigate = useNavigate();
  const ProductionStations = [
    {
      id: 1,
      name: "Mixing ",
    },
    {
      id: 2,
      name: "Make Up  ",
    },
    {
      id: 3,
      name: "Proofing ",
    },
    {
      id: 4,
      name: "Oven ",
    },
    {
      id: 5,
      name: "Chilling ",
    },
    {
      id: 6,
      name: "Packaging ",
    },
  ];

  return (
    <div className={styles.mainCont}>
      <div className={styles.HeadingDiv}>
        <HeadingComponent
          text={"Bakery Setup"}
          fontSize={"var(--heading-font-size)"}
          fontFamily={"Poppins-bold"}
        />
      </div>
      <div className={styles.subCont}>
        <div className={styles.leftCont}>
          <HeadingComponent
            text={"Production Stations "}
            padding={"0px"}
            fontSize={16}
          />
          <div className={styles.Box}>
            {ProductionStations.map((item, index) => {
              return (
                <div key={item?.id} className={styles.ItemDiv}>
                  <Switch
                    SwitchContainerStyle={styles.SwitchContainerStyle}
                    label={item?.name}
                    SwitchLabelStyle={styles.SwitchLabelStyle}
                    defaultChecked
                    size="small"
                    inactiveColor={"var(--switch-Inactive-color)"}
                    activeColor={"var(--switch-active-color)"}
                  />
                </div>
              );
            })}
          </div>
          <HeadingComponent text={"Production Stations "} fontSize={16} />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Station-Based: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "All tasks are assigned to the entire department and all staff involved"
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"User-Based: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={" Individual Staff members are assigned to a task"}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>

          <HeadingComponent text={"Staff Self-Assignment "} fontSize={16} />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Enabled: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={" Individual Staff members are assigned to a task"}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Disabled:"}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Tasks are visible only once assigned by a Supervisor"
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
        </div>
        <div className={styles.rightCont}>
          <HeadingComponent
            text={"Mixing Station Configuration"}
            fontSize={16}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Single Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "One shared Mixing station for both bread and pastry."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <HeadingComponent
            text={"Make Up Station Configuration"}
            fontSize={16}
          />
          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Single Make Up Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "One shared Make Up Station for both bread and pastry."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <HeadingComponent text={"Waste Logging"} fontSize={16} />
          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <HeadingComponent text={"Measurement Units"} fontSize={16} />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <HeadingComponent text={"Instruction Checklist"} fontSize={16} />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <HeadingComponent text={"Compliance Checklist"} fontSize={16} />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <HeadingComponent
            text={"Production Schedule Merging"}
            fontSize={16}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Disabled:  "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Each task will be treated as a unique task on the schedule."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <div
            style={{
              flexDirection: "row",
              justifyItems: "flex-end",
              width: "100%",
            }}
          >
            <SubmitButton
              onClick={() => navigate("/")}
              title={"Continue"}
              btnContainerClass={styles.btnContainer}
              primary
              btnClass={`${styles.btn}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminBakerySetup;
